import React, { useRef, useState } from 'react';
import { ArrowRight, Check, Paperclip, X } from 'lucide-react';
import { budgetRanges, company, projectTypes } from '../data/site';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
type Status = 'idle' | 'submitting' | 'success' | 'error';
const fieldClass = 'w-full border border-mist-200 bg-white px-4 py-3.5 text-sm text-navy outline-none transition placeholder:text-mist-400 focus:border-brand-500 focus:ring-2 focus:ring-brand-500/15';
const labelClass = 'mb-2 block text-[11px] font-semibold uppercase tracking-[0.16em] text-navy';
export function Contact() {
  const [status, setStatus] = useState<Status>('idle');
  const [files, setFiles] = useState<string[]>([]);
  const fileInput = useRef<HTMLInputElement>(null);
  const handleFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const list = e.target.files;
    if (!list) return;
    setFiles(Array.from(list).map(f => f.name));
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (status === 'submitting') return;
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 1000);
  };
  return <section id="contact" className="w-full bg-mist py-24 lg:py-32" data-id="element-74" data-mp="3b3j5h194k8j1">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8" data-id="element-75" data-mp="3b16kef82li1r">
        <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-76" data-mp="3f3jshaaahs1p">
          <Reveal data-id="element-77" data-mp="314k0bsnkiv0s">
            <SectionHeading label="Free Estimate" title={<>
                  Let's build
                  <br data-id="element-79" data-mp="361toz634v2nk" />
                  something great.
                </>} description="Tell us about your project and let's talk about what's possible. Most estimates are returned within one business day." data-id="element-78" data-mp="31421qpdfo4pp" />

            <div className="mt-12 border-t border-mist-200 pt-10" data-id="element-80" data-mp="qe3fg8hqcnug">
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-mist-400" data-id="element-81" data-mp="uedlfl5ive9b">Prefer to talk?</p>
              <a href={company.phoneHref} className="mt-3 block font-heading text-3xl font-extrabold tracking-tight text-navy transition hover:text-brand-600 sm:text-4xl" data-id="element-82" data-mp="23c3p1m1u0zc2">
                {company.phone}
              </a>
              <a href={`mailto:${company.email}`} className="mt-3 block break-all text-sm font-semibold text-mist-600 transition hover:text-brand-600" data-id="element-83" data-mp="1ucqm7c87r90b">
                {company.email}
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-84" data-mp="2i2kzfuwg2zl3">
            <div className="border border-mist-200 bg-white p-7 sm:p-10" data-id="element-85" data-mp="2d9i4bic0ri2s">
              {status === 'success' ? <div className="flex min-h-[520px] flex-col items-center justify-center text-center" data-id="element-86" data-mp="28bgjosyy3ap7">
                  <span className="inline-flex h-16 w-16 items-center justify-center bg-brand-500 text-white" data-id="element-87" data-mp="35qb0l8cmikui">
                    <Check className="h-7 w-7" aria-hidden="true" data-id="element-88" data-mp="30yki2f3j8qs0" />
                  </span>
                  <h3 className="mt-8 font-heading text-3xl font-extrabold uppercase tracking-tight text-navy" data-id="element-89" data-mp="38bine6ohw23c">
                    Request received
                  </h3>
                  <p className="mt-4 max-w-sm text-sm leading-relaxed text-mist-600" data-id="element-90" data-mp="3i8wrr7x590fa">
                    Thanks for reaching out. A member of the Pure Build team will follow up shortly. If it's urgent,
                    call {company.phone}.
                  </p>
                  <button type="button" onClick={() => {
                setStatus('idle');
                setFiles([]);
              }} className="mt-8 border-b-2 border-navy pb-1 text-[12px] font-bold uppercase tracking-[0.16em] text-navy transition hover:border-brand-500 hover:text-brand-600" data-id="element-91" data-mp="3r78rbzfzn8jv">
                    Send another request
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-92" data-mp="ir6xxspjarrm">
                  <div className="grid gap-6 sm:grid-cols-2" data-id="element-93" data-mp="559k9j82glse">
                    <div data-id="element-94" data-mp="15r22v7mqot9">
                      <label htmlFor="name" className={labelClass} data-id="element-95" data-mp="14fvknmsv2yg">
                        Name
                      </label>
                      <input id="name" name="name" required autoComplete="name" className={fieldClass} placeholder="Jane Doe" data-id="element-96" data-mp="eyqe2n87e0w2" />
                    </div>
                    <div data-id="element-97" data-mp="3icksdvij6lhr">
                      <label htmlFor="email" className={labelClass} data-id="element-98" data-mp="3idur8mx7jxpg">
                        Email
                      </label>
                      <input id="email" name="email" type="email" required autoComplete="email" className={fieldClass} placeholder="jane@email.com" data-id="element-99" data-mp="3ee3t1y5cqfaw" />
                    </div>
                  </div>

                  <div className="grid gap-6 sm:grid-cols-2" data-id="element-100" data-mp="12oazrdvqrc91">
                    <div data-id="element-101" data-mp="2kis3c29q4wbn">
                      <label htmlFor="phone" className={labelClass} data-id="element-102" data-mp="2kiiewj4bux82">
                        Phone
                      </label>
                      <input id="phone" name="phone" type="tel" autoComplete="tel" className={fieldClass} placeholder="615-000-0000" data-id="element-103" data-mp="2bj549n4gw2lr" />
                    </div>
                    <div data-id="element-104" data-mp="389ns0qivvbeo">
                      <label htmlFor="projectType" className={labelClass} data-id="element-105" data-mp="388w8ie2k944r">
                        Project Type
                      </label>
                      <select id="projectType" name="projectType" required defaultValue="" className={fieldClass} data-id="element-106" data-mp="2zh42qgohej6i">
                        <option value="" disabled data-id="element-107" data-mp="3n653dhr2oq18">
                          Select a project type
                        </option>
                        {projectTypes.map(t => <option key={t} value={t} data-id="element-108" data-mp="5nzgnp9jouoz">
                            {t}
                          </option>)}
                      </select>
                    </div>
                  </div>

                  <div className="grid gap-6 sm:grid-cols-2" data-id="element-109" data-mp="3ruelw9g0habu">
                    <div data-id="element-110" data-mp="3rx0so6v2vlt0">
                      <label htmlFor="address" className={labelClass} data-id="element-111" data-mp="3mwmjglhqq5te">
                        Project Address
                      </label>
                      <input id="address" name="address" autoComplete="street-address" className={fieldClass} placeholder="City or full address" data-id="element-112" data-mp="3iw2krdhiqu55" />
                    </div>
                    <div data-id="element-113" data-mp="343ilinxhp6sz">
                      <label htmlFor="budget" className={labelClass} data-id="element-114" data-mp="2z6inn0asnacy">
                        Estimated Budget
                      </label>
                      <select id="budget" name="budget" defaultValue="" className={fieldClass} data-id="element-115" data-mp="2v689h0culdn0">
                        <option value="" disabled data-id="element-116" data-mp="1aluuu87fl297">
                          Select a range
                        </option>
                        {budgetRanges.map(b => <option key={b} value={b} data-id="element-117" data-mp="1jn2m46bj52ts">
                            {b}
                          </option>)}
                      </select>
                    </div>
                  </div>

                  <div data-id="element-118" data-mp="r085jkhu2nll">
                    <label htmlFor="details" className={labelClass} data-id="element-119" data-mp="qwu3kdd30geo">
                      Tell us about your project
                    </label>
                    <textarea id="details" name="details" rows={5} required className={[fieldClass, 'resize-y'].join(' ')} placeholder="Scope, size, timeline, and anything else that helps us quote it accurately." data-id="element-120" data-mp="10wkyuh9guzft" />
                  </div>

                  <div data-id="element-121" data-mp="32pas4vuqexml">
                    <span className={labelClass} data-id="element-122" data-mp="32qlq2f1hxb5s">Photos or Plans (optional)</span>
                    <input ref={fileInput} id="attachments" name="attachments" type="file" multiple accept="image/*,.pdf" onChange={handleFiles} className="sr-only" data-id="element-123" data-mp="2xr0vshx9tqze" />
                    <button type="button" onClick={() => fileInput.current?.click()} className="flex w-full items-center justify-center gap-3 border border-dashed border-mist-200 bg-mist px-4 py-6 text-sm font-semibold text-mist-600 transition hover:border-brand-500 hover:text-brand-600" data-id="element-124" data-mp="3lm3h4fwv9cb4">
                      <Paperclip className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="89te1bazhuj3" />
                      Attach photos or plans
                    </button>
                    {files.length > 0 && <ul className="mt-3 space-y-2" data-id="element-126" data-mp="mws16u2t62s0">
                        {files.map(f => <li key={f} className="flex items-center justify-between bg-mist px-3 py-2 text-xs text-mist-600" data-id="element-127" data-mp="rutndnvj6i7p">
                            <span className="truncate" data-id="element-128" data-mp="hvb5dcz6l6ia">{f}</span>
                            <button type="button" onClick={() => setFiles(prev => prev.filter(n => n !== f))} aria-label={`Remove ${f}`} className="ml-3 text-mist-400 transition hover:text-navy" data-id="element-129" data-mp="44pti8859wtw">
                              <X className="h-3.5 w-3.5" data-id="element-130" data-mp="3v9pkxnx12vm7" />
                            </button>
                          </li>)}
                      </ul>}
                  </div>

                  {status === 'error' && <p role="alert" className="border-l-2 border-red-500 bg-red-50 px-4 py-3 text-sm text-red-700" data-id="element-131" data-mp="3ioi1v5bt8p83">
                      Something went wrong. Please try again or call {company.phone}.
                    </p>}

                  <button type="submit" disabled={status === 'submitting'} className="group flex w-full items-center justify-center gap-3 bg-brand-500 px-8 py-5 text-[13px] font-bold uppercase tracking-[0.16em] text-white transition hover:bg-brand-600 disabled:opacity-60" data-id="element-132" data-mp="3dqzz5wodz68j">
                    {status === 'submitting' ? 'Sending…' : 'Request a Free Estimate'}
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden="true" data-id="element-133" data-mp="j5defvb14ay" />
                  </button>

                  <p className="text-center text-xs text-mist-400" data-id="element-134" data-mp="t22a2dulmny7">
                    No pressure. No obligation. Just a conversation about your project.
                  </p>
                </form>}
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}